import { Column as TableColumn, ColumnType } from "../../components/datatable/interfaces";
import { SewerObjectSummaryResponse } from "../../api-models/response/SewerObjectSummaryResponse";
import { endpoints } from "../api/ApiEndpoints";
import { DataGridStorageModel } from "../../components/datatable/DataGridStorage";
import { getTranslationKeyForType } from "./SewerObject";
import { SewerObjectSummary } from "./SewerObjectSummary";
import { SewerObjectType } from "../../generated/SewerObjects";

const tableColumns: TableColumn[] = [
  {
    key: "name",
    name: "sewer-objects.AddExistingSewerObjectsToJob.list-header.id",
    type: ColumnType.String,
    filterable: true,
  },
  {
    key: "type",
    name: "sewer-objects.AddExistingSewerObjectsToJob.list-header.type",
    type: ColumnType.SingleSelect,
    valueOptions: [
      {
        label: getTranslationKeyForType(SewerObjectType.Section),
        value: SewerObjectType.Section.toString(),
      },
      {
        label: getTranslationKeyForType(SewerObjectType.Node),
        value: SewerObjectType.Node.toString(),
      },
      {
        label: getTranslationKeyForType(SewerObjectType.Structure),
        value: SewerObjectType.Structure.toString(),
      },
    ],
    filterable: true,
  },
  {
    key: "openJobsCount",
    name: "sewer-objects.AddExistingSewerObjectsToJob.list-header.openjobs",
    type: ColumnType.Number,
    filterable: true,
  },
  {
    key: "modified",
    name: "general.last-edit",
    type: ColumnType.DateTime,
    filterable: true,
  },
];

export const SewerObjectsSummaryStorageModel = DataGridStorageModel.named(
  "SewerObjectsSummaryStorageModel"
)
  .actions(() => {
    return {
      mapItem(sewerObjectSummaryResponse: SewerObjectSummaryResponse) {
        return new SewerObjectSummary(sewerObjectSummaryResponse);
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("sewer_objects_summary");
      endpoint.queryParams = self.getDataQuery();
      return endpoint;
    },
    get canLoadItems() {
      return !!self.filterData.contextFilter;
    },
    get columns() {
      return tableColumns;
    },
  }));
